module.exports = __webpack_public_path__ + "img/banner.ea1c751d.png";